import styled from 'styled-components'
import { H, P, Wrapper } from '@farewill/ui'
import { BORDER } from '@farewill/ui/tokens'
import { ProbateEstatePerson } from 'lib/models/probate-estate'
import {
  getManualFormSentValue,
  getManualFormConfirmedValue,
  type Provider,
  type Mode,
} from '../helpers/complete-sections/section-referral'
import { ActingExecutorChecks } from './acting-executor-checks'

const StyledWrapper = styled(Wrapper)`
  border-radius: ${BORDER.RADIUS.M};
`

export type AutomatedFormState = {
  sentAt: Date | null
  receivedAt: Date | null
}

export type ProbateCheckProvider = {
  provider: Provider
  formTitle: string
  automatedForm: {
    title: string
    description: string
    state: (personId: number) => Promise<AutomatedFormState>
    submit: (personId: number) => Promise<AutomatedFormState>
  }
  manualForm: {
    title: string
    description: string
    sendToggle: (personId: number, date: Date | null) => Promise<void>
    confirmToggle: (personId: number, date: Date | null) => Promise<void>
    confirmedAction: string
  }
  detectMode: (
    personId: number,
    autoState: AutomatedFormState | null,
    manualSentValue: Date | null
  ) => Mode
}

export const ActingExecutorsChecks = ({
  people,
  providers,
}: {
  people: ProbateEstatePerson[]
  providers: ProbateCheckProvider[]
}) => {
  return (
    <Wrapper margin={['L', 0, 0]}>
      <H size="XS">Acting executors</H>
      <P color="GREY.DARK">
        Each acting executor must sign:
        <br />
        Terms & Conditions (T&Cs); Know your customer (KYC); Anti money
        laundering laundering checks (AML)
      </P>

      {people.map((person, index) => {
        const personName = `${person.attributes.title ?? ''} ${
          person.attributes.firstNames
        } ${person.attributes.lastName}`.trim()
        return (
          <StyledWrapper
            data-testid={`probate-checks-person-${index + 1}`}
            key={person.id}
            bordered
            padding="M"
            margin={['L', 0, 0]}
          >
            <H size="XS" margin="0">
              {personName}
            </H>
            {providers.map((provider) => {
              const key = `probate-checks-person-${index + 1}-${
                provider.provider
              }`
              const manualFormSentValue = getManualFormSentValue(
                provider.provider,
                person
              )
              const manualFormConfirmedValue = getManualFormConfirmedValue(
                provider.provider,
                person
              )
              return (
                <ActingExecutorChecks
                  key={key}
                  testId={key}
                  personId={person.id}
                  email={person.attributes.email}
                  provider={provider.provider}
                  formTitle={provider.formTitle}
                  automatedForm={provider.automatedForm}
                  manualForm={{
                    ...provider.manualForm,
                    sentValue: manualFormSentValue,
                    confirmedValue: manualFormConfirmedValue,
                  }}
                  detectMode={provider.detectMode}
                />
              )
            })}
          </StyledWrapper>
        )
      })}
    </Wrapper>
  )
}
